import { faFloppyDisk } from '@fortawesome/pro-duotone-svg-icons';
import { faPenToSquare } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useShoppingCartsContext } from 'context/ShoppingCartsContext';
import { useNavigate } from 'react-router';
import { tss } from 'tss-react';

import { RecipeErpViewComponentProps } from 'components/desktop/ShoppingCart/Detail/Index';
import { EAlertType } from 'enums/alertType';
import { fireAlert } from 'functions/fireAlert';
import { useIsHandlerLoaded } from 'hooks/useIsLoading';
import useTranslation from 'hooks/useTranslation';

interface IProps extends RecipeErpViewComponentProps {}

const ButtonGroup = ({ handlers, cart }: IProps) => {
	const { classes } = useStyles();
	const { t } = useTranslation();
	const carts = useShoppingCartsContext();
	const navigate = useNavigate();

	const [_isLoaded, saveCart] = useIsHandlerLoaded(async () => {
		await carts.saveCart(cart.id);
		fireAlert(EAlertType.success, t('_general:BTN_SAVE'), t('shoppingCart:SAVE_MESSAGE'));
		if (!cart.id) {
			navigate('/shoppingCart/search');
		}
	});

	return (
		<div className={classes.container}>
			<button
				type="button"
				className="btn btn-outline-primary"
				onClick={handlers.toggleEditMode}
			>
				<FontAwesomeIcon icon={faPenToSquare} className={classes.icon} />
				{t('_general:EDIT')}
			</button>
			<button type="button" className="btn btn-primary" onClick={saveCart}>
				<FontAwesomeIcon icon={faFloppyDisk} className={classes.icon} />
				{t('_general:BTN_SAVE')}
			</button>
		</div>
	);
};

export const useStyles = tss.create({
	container: {
		display: 'flex',
		gap: '5px',
		'>button': {
			alignSelf: 'start',
		},
	},
	icon: {
		marginRight: '8px',
	},
});

export default ButtonGroup;
